// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3fN3G","legacyBtn":"MutateMid_legacyBtn__3JrGR"};